<!-- #region FIX PART -->
<!-- <section>
  <div class="head">
    <img class="logo" src="assets/icons/join_logo.svg" alt="Join logo" />
    <div class="login-btn-container">
      <button class="login-btn" (click)="goToLogin()">
        <img src="assets/icons/login.svg" alt="" />
        <span>Log In / Sign Up</span>
      </button>
    </div>
  </div>

  <div class="nav-btn">
    <button
      (click)="navigateTo('privacy-policy')"
      [class.active]="activeComponent === 'privacy-policy'"
    >
      Privacy Policy
    </button>
    <button
      (click)="navigateTo('legal-notice')"
      [class.active]="activeComponent === 'legal-notice'"
    >
      Legal Notice
    </button>
  </div>
</section> -->
<app-nav-bar [context]="'login'" (selectedActiveComponent)="handleNavbarNavigation($event)" [nowOpen]="activeComponent" ></app-nav-bar>
<div class="content-wrapper">
  <app-header [context]="'login'"></app-header>
  <!-- #endregion -->
  <!-- #region SWITCHABLE PART -->
  <div>
    <app-legal-notice [context]="'login'"
      *ngIf="activeComponent === 'legal-notice'"
    ></app-legal-notice>
    <app-privacy-policy [context]="'login'"
      *ngIf="activeComponent === 'privacy-policy'"
    ></app-privacy-policy>
  </div>
  <!-- #endregion -->
</div>
